import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { LoadMore } from 'react-weui'
import { browserHistory } from 'react-router'
import { Page, WKTab } from '../../components'
import { WKSearch, WKVisible, WKInfiniteScroll } from '../../components/wk'
import MediaItem from './MediaItem'
import ResellNoItem from './ResellNoItem'
import '../../css/page/ResellPage.css'


class ResellStore extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            offset: 0,
            hasMore: true,
            liverooms: [],
            isPending: false,
            stats_info: {},
        }
    }
    componentDidMount () {
        this.fetchData()

    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get('/api/resell/my/agents', {
            params: {
                offset: this.state.offset,
            }
        })
            .then(res => {
                this.setState({
                    isPending: false,
                    liverooms: this.state.liverooms.concat(res.data.data.agents),
                    stats_info: res.data.data.stats_info,
                    offset: res.data.data.offset,
                    hasMore: res.data.data.has_more,
                })
            })
    }
    getStateInfo (state) {
        switch (state) {
            case 'approved':
                return { text: '已激活', style: 'active' }
            case 'delete_frozen':
                return { text: '已失效', style: '' }
            case 'frozen':
                return { text: '已冻结', style: '' }
        }
    }
    onClickItem (id) {
        location.assign(`/resell/liveroom/${id}`)
    }
    render() {
        const { stats_info, liverooms } = this.state
        const isEmpty = stats_info.approved_count === 0 && stats_info.delete_frozen_count === 0 && stats_info.frozen_count === 0
        return (
            <div className='resell-liveroom-list-page wk-page'>
                <ResellNoItem 
                    show={isEmpty}
                    text='暂无加入直播间分销商的记录'
                />
                <WKVisible create={!isEmpty}>
                    <div className="title wk-border-line-after wk-position-rlt">
                        <span className='margin-right'>已激活：<span className='green'>{stats_info.approved_count}个</span></span>
                        <span className='margin-right'>已失效：{stats_info.delete_frozen_count}个</span>
                        <span>已冻结：{stats_info.frozen_count}个</span>
                    </div>
                </WKVisible>
                {
                    liverooms.map(item => (
                        <MediaItem
                            key={item.id}
                            onClick={e => this.onClickItem(item.id)}
                            content={{
                                cover: item.avatar_url,
                                topText: item.liveroom_name,
                                middleText: `佣金比例：${item.percent}%`,
                                bottomHtml: `<p>当前状态：<span class='${this.getStateInfo(item.state).style}'>${this.getStateInfo(item.state).text}</span></p>`,
                            }}
                        />
                    ))
                }
                <WKInfiniteScroll 
                    onTouchBottom={() => this.fetchData()} 
                    isStop={this.state.isPending} 
                    isKill={!this.state.hasMore}
                    isShowLoading={true}
                />
            </div>
        )
    }
}

export default connect(state => ({
    
}))(ResellStore)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellLiveroomsPage.js